import React, { useEffect, useState, useContext, useRef } from "react";
import { UserContext } from "../../context/UserContext";
import { LoaderContext } from "../../context/LoaderContext";
import "./File.css";

import fileIcon from "../../assets/images/file-icon.png";
import pdfIcon from "../../assets/images/pdf-icon.png";
import xlsIcon from "../../assets/images/xls-icon.png";
import xlsxIcon from "../../assets/images/xlsx-icon.png";
import csvIcon from "../../assets/images/csv-icon.png";
import docIcon from "../../assets/images/doc-icon.png";
import docsIcon from "../../assets/images/docs-icon.png";
import docxIcon from "../../assets/images/docx-icon.png";
import pngIcon from "../../assets/images/png-icon.png";
import mp4Icon from "../../assets/images/mp4-icon.png";

import mp3Icon from "../../assets/images/mp3-icon.png";
import wavIcon from "../../assets/images/wav-icon.png";
import oggIcon from "../../assets/images/ogg-icon.png";
import aacIcon from "../../assets/images/aac-icon.png";
import webmIcon from "../../assets/images/webm-icon.png";

import txtIcon from "../../assets/images/txt-icon.png";
import failedIcon from "../../assets/images/file-fail.png";

import settingsIcon from "../../assets/images/settingsIcon.png";
import downloadIcon from "../../assets/images/downloadIconLight.png";
import exitIcon from "../../assets/images/exitLight.png";
import { API_URL, MAX_PREVIEW_MB } from "../../environmentVariables";
import EditObjectModal from "../Modals/EditObjectModal/EditObjectModal";
import {
  Alert,
  BytesToMb,
  GetObjectToken,
  GetSessionUrls,
  isMobileDevice,
  Log,
  RemoveSessionUrl,
  TrackSessionUrl,
  TruncateText,
  wait,
} from "../../utils/genericUtils";
import { PATCH, setAuth } from "../../utils/httpUtils";
import { AlertContext } from "../../context/AlertContext";
import ObjectPasswordModal from "../Modals/ObjectPasswordModal/object-password-modal";

import lockLight from "../../assets/images/lockLight.png";
import lockDark from "../../assets/images/lock.png";
import ThemeContext from "../../context/ThemeContext";

function File(props) {
  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { theme } = useContext(ThemeContext);
  const { globalAlert } = useContext(AlertContext);

  const [objectId, setObjectId] = useState(null);
  const [initialRename, setInitialRename] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [listenerSet, setListenerSet] = useState(false);
  const [preview, setPreview] = useState(null);
  const isRenaming = useRef(false);
  const sessionUrl = useRef(null);
  const thumbnailSet = useRef(false);
  const [editModalActive, setEditModalActive] = useState(false);
  const [failedLoad, setFailedLoad] = useState(false);

  const mobileClickCount = useRef(0);

  //locked flow
  const [objectPasswordModalActive, setObjectPasswordModalActive] = useState(false);

  const [unlocked, setUnlocked] = useState(GetObjectToken(props.objectId) ?? false);

  const lockIcon = theme === "light" ? lockDark : lockLight;

  const [fileName, setFileName] = useState(props.fileName);

  useEffect(() => {
    props.isPsuedo && Log("psuedo props: ", props);
    GetPreview();

    //dont assign listeners if psuedo
    if (props.isPsuedo || props.locked || failedLoad) return;

    //do not assign these listeners if the object is in the trash or isPsuedo
    if (props.directory) {
      let dir_parts = props.directory.split("/");
      if (dir_parts[0].toLowerCase() === "trash" || dir_parts[1].toLowerCase() === "trash") {
        return;
      }
    }

    if (props.objectId) setObjectId(props.objectId);

    let input = document.querySelector("#object-" + props.objectId + "-rename-input");

    if (initialRename) {
      input.focus();

      input.addEventListener("blur", async () => {
        await UpdatefileName(input.value);
      });

      input.addEventListener("keydown", async (event) => {
        if (event.keyCode === 13) {
          await UpdatefileName(input.value);
        }
      });
    } else {
      const keydownListener = async (event) => {
        if (event.keyCode === 13) {
          //input.removeEventListener("keydown", keydownListener);
          let pTag = document.querySelector("#object-" + props.objectId + "-file-name");
          input.style.display = "none";
          pTag.style.display = "flex";
          pTag.focus();
          Log("is renaming:", isRenaming.current);
          UpdatefileName(input.value);
        }
      };
      input.addEventListener("keydown", keydownListener);
    }

    if (!listenerSet && objectId && !initialRename && !isMobileDevice()) {
      Log("setting listener : " + objectId);
      let pTag = document.querySelector("#object-" + objectId + "-file-name");
      let input = document.querySelector("#object-" + objectId + "-rename-input");
      const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        doubleClickEditName(pTag, input);
      };
      pTag.addEventListener("click", handleClick);
      setListenerSet(true);

      return () => {
        pTag.removeEventListener("click", handleClick);
      };
    }
  }, [initialRename, objectId, props.directory, unlocked, objectPasswordModalActive, failedLoad]);

  //reset file name if props changed
  useEffect(() => {
    if (fileName !== props.fileName) setFileName(props.fileName);
  }, [props.fileName]);

  function UpdatefileName(name) {
    //do not edit if name has not changed
    if (name === props.objectName) return;
    if (isRenaming.current === true) return;
    //do not allow api call if same name is input
    if (name === props.fileName) {
      props.forceUpdate();
      return;
    }
    showloader();
    isRenaming.current = true;

    let body = {
      objectId: props.id,
      objectName: name,
    };

    PATCH("/rename-object", body, user, [{ key: "x-file-dir", value: props.directory }]).then((response) => {
      isRenaming.current = false; //reset isRenaming to false
      if (response.success) {
        props.forceUpdate();
      } else {
        props.forceUpdate();
      }
    });
  }

  function doubleClickEditName(pTag, input) {
    Log("failed to load: ", failedLoad);

    if (failedLoad === true) return;

    setClickCount((prevCount) => {
      const newCount = prevCount + 1;
      if (newCount >= 2) {
        // If user clicks twice rapidly
        pTag.style.display = "none";
        input.style.display = "flex";
        input.focus();
      } else {
        setTimeout(() => {
          setClickCount(0);
        }, 500);
      }
      return newCount;
    });
  }

  function OnInPutFocusOut() {
    let pTag = document.querySelector("#object-" + props.objectId + "-file-name");
    let input = document.querySelector("#object-" + props.objectId + "-rename-input");
    pTag.style.display = "block";
    input.style.display = "none";
    pTag.focus();
  }

  function showObjectModal() {
    setEditModalActive(true);
  }

  function GetPreview() {
    if (props.locked && !unlocked) {
      setPreview(<img src={lockIcon} alt="locked object" onClick={() => setObjectPasswordModalActive(true)} />);
      return;
    }

    let fileExtension = props.fileName.split(".").pop().toLowerCase();
    switch (fileExtension) {
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "webp":
      case "avif":
        return GetImagePreview();
      case "mp4":
      case "mts":
        return GetVideoPreview();
      case "mp3":
      case "wav":
      case "aac":
      case "ogg":
      case "webm":
        return GetOtherFilePreview();
      default:
        return GetOtherFilePreview();
    }
  }

  function GetOtherFilePreview() {
    setPreview(<img src={getProperIcon()} onClick={handleClick} />);
  }

  async function GetImagePreview(force_get = false) {
    setPreview(
      <>
        <img src={getProperIcon()} />
      </>
    );

    if (BytesToMb(props.size) < MAX_PREVIEW_MB) {
      let session_url = GetSessionUrls().find((x) => x.objectId === props.id);

      let _url = null;
      if (session_url && !force_get) {
        _url = session_url ? session_url.url : null;
        sessionUrl.current = _url;
      }

      if (!_url) {
        let f = await GetFile(props.id);

        if (f) {
          let url = f.url;
          sessionUrl.current = url;
          _url = url;
          TrackSessionUrl(props.id, url);
        } else {
          _url = failedIcon;
          setFailedLoad(true);
        }
      }

      //Alert(globalAlert, "info", "url", _url);

      setPreview(
        <img
          className="img-preview"
          src={_url}
          title={failedLoad ? "Failed To Load Preview" : undefined}
          onClick={handleClick}
          onError={(e) => {
            Log("failed to load image: ", props);
            //Alert(globalAlert, "error", "Failed to Load Image", _url);
            e.target.src = getProperIcon();
            //prevent image preview popup in event of image load error
            e.target.addEventListener("click", (e) => {
              hideEnlargedImagePreview(e);
            });

            //if the cached blob url isn't working try and force a GET from the api
            if (session_url) {
              //remove the non working session url from memory
              RemoveSessionUrl(session_url);
              GetImagePreview(true);
              return;
            }
          }}
        />
      );
    }
  }

  async function GetVideoPreview() {
    setPreview(<img src={getProperIcon()} onClick={handleClick} />);

    if (BytesToMb(props.size) <= MAX_PREVIEW_MB) {
      //let session_url = GetSessionUrls().find((x) => x.objectId === props.id);

      // let _url = null;
      // if (session_url) {
      //   _url = session_url ? session_url.url : null;
      //   sessionUrl.current = _url;
      // }

      // if (!_url) {
      //   let f = await GetFileStreamed(props.id);
      //   if (f) {
      //     let url = f.url;
      //     sessionUrl.current = url;
      //     _url = url;
      //     TrackSessionUrl(props.id, url);
      //   }
      // }

      let jwt = localStorage.getItem("jwt") ?? sessionStorage.getItem("jwt");

      const handleSeek = (e) => {
        const video = e.target;
        const buffered = video.buffered;

        if (buffered.length > 0) {
          const end = buffered.end(buffered.length - 1); // Get the end of the last buffered range

          if (e.target.currentTime <= end) {
            // Let the user seek to this point
            Log("Seeking within buffered range.");
          } else {
            // Seek to the available buffered range
            Log("Seeking to the last buffered point.");
            video.currentTime = end;
          }
        }
      };

      setPreview(
        <video
          onClick={handleClick}
          src={`${API_URL}/get-file/${props.id}?token=${jwt}#t=2`}
          preload="auto"
          onSeeking={handleSeek}
          onError={(e) => {
            Log("load video error: ", e);
            setPreview(
              <img
                src={getProperIcon()}
                onClick={() => {
                  Log(e);
                }}
              />
            );
          }}
        ></video>
      );
    }
  }

  async function GetAudioPreview(force_get = false) {
    setPreview(
      <>
        <img src={getProperIcon()} />
      </>
    );

    if (BytesToMb(props.size) < MAX_PREVIEW_MB) {
      let session_url = GetSessionUrls().find((x) => x.objectId === props.id);

      let _url = null;
      if (session_url && !force_get) {
        _url = session_url ? session_url.url : null;
        sessionUrl.current = _url;
      }

      if (!_url) {
        let f = await GetFile(props.id);

        if (f) {
          let url = f.url;
          sessionUrl.current = url;
          _url = url;
          TrackSessionUrl(props.id, url);
        }
      }

      //Alert(globalAlert, "info", "url", _url);

      setPreview(
        <>
          <audio
            controls
            className="audio-preview"
            src={_url}
            onClick={handleClick}
            onError={(e) => {
              e.target.src = getProperIcon();
              //prevent image preview popup in event of image load error
              e.target.addEventListener("click", (e) => {
                hideEnlargedImagePreview(e);
              });

              //if the cached blob url isn't working try and force a GET from the api
              if (session_url) {
                //remove the non working session url from memory
                RemoveSessionUrl(session_url);
                GetImagePreview(true);
                return;
              }
            }}
          ></audio>
        </>
      );
    }
  }

  function getProperIcon() {
    let fileExtension = props.fileName.split(".").pop().toLowerCase();
    switch (fileExtension) {
      case "png":
      case "jpg":
      case "jpeg":
      case "webp":
        return pngIcon;
      case "txt":
        return txtIcon;
      case "mp4":
      case "mts":
        return mp4Icon;
      //audio
      case "mp3":
        return mp3Icon;
      case "wav":
        return wavIcon;
      case "ogg":
        return oggIcon;
      case "aac":
        return aacIcon;
      case "webm":
        return webmIcon;
      //spreadsheets
      case "xls":
        return xlsIcon;
      case "xlsx":
        return xlsxIcon;
      case "csv":
        return csvIcon;
      case "pdf":
        return pdfIcon;
      case "doc":
        return docIcon;
      case "docs":
        return docsIcon;
      case "docx":
        return docxIcon;
      default:
        return fileIcon;
    }
  }

  async function DownloadFile() {
    try {
      showloader();
      let f = await GetFile(props.id);
      hideloader();
      if (f) {
        // Create a link element
        let link = document.createElement("a");
        link.href = f.url;
        link.download = f.fileName; // Set the default filename for the download

        // Append the link to the document body (required for Firefox)
        document.body.appendChild(link);
        hideloader();
        // Trigger a click event on the link to start the download
        link.click();

        URL.revokeObjectURL(f.url); //revoke the url to save memory

        // Remove the link from the document body
        document.body.removeChild(link);
      } else {
        Alert(globalAlert, "error", "Error", "Something went wrong! Download failed.");
      }
    } catch (error) {
      Alert(globalAlert, "error", "Error", `Something went wrong! Download failed: ${error.message}`);
    }
  }

  function GetFile(objectId) {
    return new Promise((resolve) => {
      let request = new XMLHttpRequest();
      request.open("GET", API_URL + "/get-file/" + objectId);

      if (props.locked) request.setRequestHeader("x-object-token", GetObjectToken(props.objectId) ?? "");

      setAuth(request, user);
      request.responseType = "blob";
      request.send();
      request.onload = () => {
        if (request.status === 200) {
          // Get the response blob
          let blob = request.response;
          // Extract filename from response headers
          let fileName = request.getResponseHeader("x-fileName");

          //if file extension is .pdf
          let fileExtension = fileName.split(".").pop();

          if (fileExtension.toLowerCase() === "pdf") {
            // Ensure the correct MIME type
            blob = new Blob([blob], { type: "application/pdf" });
          }

          //if file extension is .doc
          if (fileExtension.toLowerCase() === "doc") {
            // Ensure the correct MIME type
            blob = new Blob([blob], { type: "application/msword" });
          }

          //if file extension is .doc
          if (fileExtension.toLowerCase() === "docx") {
            // Ensure the correct MIME type
            blob = new Blob([blob], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
          }

          // Create a blob URL for the response blob
          let url = URL.createObjectURL(blob);
          return resolve({ fileName, url });
        } else {
          return resolve(null);
        }
      };
    });
  }

  function GetFileStreamed(objectId) {
    //handle auth
    if (!localStorage.getItem("jwt") && !sessionStorage.getItem("jwt")) return;
    let jwt = localStorage.getItem("jwt") ?? sessionStorage.getItem("jwt");

    return fetch(API_URL + "/get-file/" + objectId, {
      method: "GET",
      headers: {
        id: user.id ?? "",
        Authorization: `${jwt}`, // or however setAuth works
      },
    })
      .then(async (response) => {
        if (!response.ok) return null;

        const contentDisposition = response.headers.get("x-fileName");
        const fileName = contentDisposition || "file";

        const contentType = response.headers.get("Content-Type") || "application/octet-stream";

        // Convert stream to blob incrementally
        const reader = response.body.getReader();
        const stream = new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value);
                push();
              });
            }
            push();
          },
        });

        const blob = await new Response(stream).blob();

        const url = URL.createObjectURL(new Blob([blob], { type: contentType }));
        return { fileName, url };
      })
      .catch(() => null);
  }

  function handleClick() {
    if (failedLoad) return;

    let fileExtension = props.fileName.split(".").pop().toLowerCase();
    Log("file extension: ", fileExtension);

    let isMobile = isMobileDevice();

    if (isMobile) {
      const nextClickCount = mobileClickCount.current + 1;
      mobileClickCount.current = nextClickCount;
      //reset count to zero if they do not double click in 1.5s
      wait(700, () => (mobileClickCount.current = 0));
      if (nextClickCount < 2) return;
    }

    switch (fileExtension) {
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "webp":
      case "avif":
        showEnlargedImagePreview(); //handle image previews
        break;
      case "txt":
        return fileIcon;
      case "mp4": // handled by browser video support
      case "mts": // handled by browser video support
        showEnlargedVideoPreview();
        break;
      case "mp3":
      case "wav":
      case "ogg":
      case "aac":
      case "webm":
        showEnlargedAudioPreview();
        break;
      case "xls":
        break;
      case "csv":
        return xlsIcon;
      case "pdf":
        showEnlargedPdfPreview();
        break;
      case "doc":
        showEnlargedDocPreview();
        break;
      case "docs":
        showEnlargedDocPreview();
        break;
      case "docx":
        showEnlargedDocPreview();
        break;
      default:
        return fileIcon;
    }

    if (isMobile) mobileClickCount.current = 0;
  }

  function showEnlargedImagePreview() {
    if (BytesToMb(props.size) <= MAX_PREVIEW_MB) {
      let id = "click-" + props.id + "-img-expanded-preview";
      let imagePreview = document.querySelector("#" + id);
      //alert('image preview defined: ' + (!!imagePreview).toString())
      imagePreview.style.display = "flex";
      imagePreview.querySelector(".target-enlarged-image").src = sessionUrl.current;
    }
  }

  function hideEnlargedImagePreview(e) {
    e.stopPropagation();
    let id = "click-" + props.id + "-img-expanded-preview";
    let imagePreview = document.querySelector("#" + id);
    imagePreview.style.display = "none";
  }

  function showEnlargedVideoPreview() {
    if (BytesToMb(props.size) <= MAX_PREVIEW_MB) {
      let id = "click-" + props.id + "-video-expanded-preview";
      let videoPreview = document.querySelector("#" + id);
      videoPreview.style.display = "flex";
      let video = videoPreview.querySelector("video");
      let jwt = localStorage.getItem("jwt") ?? sessionStorage.getItem("jwt");
      video.src = `${API_URL}/get-file/${props.id}?token=${jwt}`;
    }
  }

  function hideEnlargedVideoPreview(e) {
    e.stopPropagation();
    let id = "click-" + props.id + "-video-expanded-preview";
    let videoPreview = document.querySelector("#" + id);
    videoPreview.style.display = "none";
    let video = videoPreview.querySelector("video");
    video.pause();
  }

  function showEnlargedAudioPreview() {
    if (BytesToMb(props.size) <= MAX_PREVIEW_MB) {
      let id = "click-" + props.id + "-audio-expanded-preview";
      let audioPreview = document.querySelector("#" + id);
      audioPreview.style.display = "flex";
      let audio = audioPreview.querySelector("audio");
      let jwt = localStorage.getItem("jwt") ?? sessionStorage.getItem("jwt");
      let session_url = GetSessionUrls().find((x) => x.objectId === props.id);
      audio.src = session_url ?? `${API_URL}/get-file/${props.id}?token=${jwt}`;
      audio.onError = (e) => {
        alert(e.toString());
        let el = e.target.src;
        if (el.src.toLowerCase().includes("blob")) {
          //set el src to direct api src if it failed from blob url
          el.src = `${API_URL}/get-file/${props.id}?token=${jwt}`;
        }
      };
    }
  }

  function hideEnlargedAudioPreview(e) {
    e.stopPropagation();
    let id = "click-" + props.id + "-audio-expanded-preview";
    let audioPreview = document.querySelector("#" + id);
    audioPreview.style.display = "none";
    let audio = audioPreview.querySelector("audio");
    audio.pause();
  }

  async function showEnlargedPdfPreview() {
    if (BytesToMb(props.size) <= MAX_PREVIEW_MB) {
      let id = "click-" + props.id + "-pdf-expanded-preview";
      let pdfPreview = document.querySelector("#" + id);
      pdfPreview.style.display = "flex";
      let iframe = pdfPreview.querySelector("iframe");
      let file = await GetFile(props.id);
      iframe.src = file.url;
    }
  }

  function hideEnlargedPdfPreview(e) {
    e.stopPropagation();
    let id = "click-" + props.id + "-pdf-expanded-preview";
    let pdfPreview = document.querySelector("#" + id);
    pdfPreview.style.display = "none";
  }

  async function showEnlargedDocPreview() {
    let id = "click-" + props.id + "-doc-expanded-preview";
    let docPreview = document.querySelector("#" + id);
    docPreview.style.display = "flex";
    let iframe = docPreview.querySelector("iframe");
    let file = await GetFile(props.id);
    iframe.src = `https://docs.google.com/gview?url=${file.url}&embedded=true`;
  }

  function hideEnlargedDocPreview(e) {
    e.stopPropagation();
    let id = "click-" + props.id + "-doc-expanded-preview";
    let pdfPreview = document.querySelector("#" + id);
    pdfPreview.style.display = "none";
  }

  function captureFrame(video, seconds) {
    // Set the video's current time to the specified seconds
    video.currentTime = seconds;

    // Create a canvas and draw the current frame of the video on it
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert the canvas content to a data URL (JPEG format in this case)
    return canvas.toDataURL("image/jpeg");
  }

  /**
   *
   * @returns
   */
  function RenderSettingsButton() {
    if (props.isPsuedo) return <></>;
    if (props.locked && !unlocked) return <></>;

    return (
      <button className="object-settings-button">
        <img onClick={showObjectModal} className="object-settings-button-icon" src={settingsIcon} />
      </button>
    );
  }

  /**
   *
   * @returns
   */
  function RenderDownloadButton() {
    if (props.isPsuedo) return <></>;
    if (props.locked && !unlocked) return <></>;

    return (
      <button className="object-download-button">
        <img onClick={DownloadFile} className="object-download-button-icon" src={downloadIcon} />
      </button>
    );
  }

  function OnUnlocked() {
    setUnlocked(true);
  }

  return (
    <>
      {props.isPsuedo ? null : (
        <EditObjectModal
          isFolder={false}
          isPublicView={props.isPublicView}
          id={props.objectId}
          isActive={editModalActive}
          objectName={props.fileName}
          directory={props.directory}
          possibleDirectories={props.possibleDirectories}
          name={props.fileName}
          public={props.public}
          hidden={props.hidden}
          locked={props.locked}
          DateCreated={props.DateCreated}
          DateModified={props.DateModified}
          bytes={props.bytes}
          onCloseModal={() => {
            setEditModalActive(false);
          }}
          isTrashBin={props.isTrashBin}
          forceUpdate={props.forceUpdate}
        />
      )}

      {/* Object Password Modal */}
      {props.locked && (
        <>
          <ObjectPasswordModal
            id={`object-password-modal-${props.objectId}`}
            icon={lockIcon}
            isActive={objectPasswordModalActive}
            onCloseModal={() => setObjectPasswordModalActive(false)}
            objectId={props.objectId}
            onUnlock={OnUnlocked}
          />
        </>
      )}

      <div id={props.objectId ?? "null"} className={props.isPsuedo ? ["psuedo", "file-element"].join(" ") : "file-element"}>
        {preview}

        {/* Image Enlargement Preview (Click) */}
        <div id={"click-" + props.id + "-img-expanded-preview"} className="expanded-preview">
          <button
            onClick={(e) => {
              //stop propagation of this event
              hideEnlargedImagePreview(e);
            }}
            className="expanded-preview-exit-button"
          >
            <img src={exitIcon} alt="exit icon" />
          </button>
          <img className="target-enlarged-image" src="" alt={"image file: " + props.objectName} />
        </div>

        {/* Video Enlargement Preview (Click) */}
        <div id={"click-" + props.id + "-video-expanded-preview"} className="expanded-preview">
          <button
            onClick={(e) => {
              //stop propagation of this event
              hideEnlargedVideoPreview(e);
            }}
            className="expanded-preview-exit-button"
          >
            <img src={exitIcon} alt="exit icon" />
          </button>
          <video controls preload="metadata" />
        </div>

        {/* Audio Enlargement Preview (Click) */}
        <div id={"click-" + props.id + "-audio-expanded-preview"} className="expanded-preview">
          <button
            onClick={(e) => {
              //stop propagation of this event
              hideEnlargedAudioPreview(e);
            }}
            className="expanded-preview-exit-button"
          >
            <img src={exitIcon} alt="exit icon" />
          </button>
          <audio controls></audio>
        </div>

        {/* PDF Enlargement Preview (Click) */}
        <div id={"click-" + props.id + "-pdf-expanded-preview"} className="expanded-preview">
          <button
            onClick={(e) => {
              //stop propagation of this event
              hideEnlargedPdfPreview(e);
            }}
            className="expanded-preview-exit-button"
          >
            <img src={exitIcon} alt="exit icon" />
          </button>
          <iframe src={null} />
        </div>

        {/* DOC/DOCX Enlargement Preview (Click) */}
        <div id={"click-" + props.id + "-doc-expanded-preview"} className="expanded-preview">
          <button
            onClick={(e) => {
              //stop propagation of this event
              hideEnlargedDocPreview(e);
            }}
            className="expanded-preview-exit-button"
          >
            <img src={exitIcon} alt="exit icon" />
          </button>
          <iframe src={null} />
        </div>

        <div className="relative-anchor">
          {!failedLoad && (
            <>
              {/* Settings Icon */}
              {RenderSettingsButton()}

              {/* Download Icon */}
              {RenderDownloadButton()}
            </>
          )}
        </div>

        {/* Name and Title Logic */}
        {initialRename && !props.isPsuedo ? (
          <input className="file-rename-input" id={"object-" + props.objectId + "-rename-input"} type="text" defaultValue={props.fileName} />
        ) : (
          <>
            <p id={"object-" + props.objectId + "-file-name"} className="file-name" title={props.fileName}>
              {TruncateText(props.fileName)}
            </p>
            {!failedLoad && (
              <input
                onBlur={OnInPutFocusOut}
                className="file-rename-input hidden-rename"
                id={"object-" + props.objectId + "-rename-input"}
                type="text"
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
              />
            )}
          </>
        )}
        {/* Progress bar to show loading progress */}
        {props.isPsuedo ? (
          <progress id={props.objectId + "-psuedo-progress"} className="psuedo-file-progress-bar" value={0} max={100}></progress>
        ) : null}
      </div>
    </>
  );
}

export default File;
